import { render, staticRenderFns } from "./MyBill.vue?vue&type=template&id=482b4b92&scoped=true&"
import script from "./MyBill.vue?vue&type=script&lang=js&"
export * from "./MyBill.vue?vue&type=script&lang=js&"
import style0 from "./MyBill.vue?vue&type=style&index=0&id=482b4b92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b4b92",
  null
  
)

export default component.exports